/* LUXURIA – gemeinsamer Datenlader für Fahrzeug-Check und "Weitere Nachrüstungen".
   Quelle 1: /collections/all?view=lux-finder (Liquid-Endpunkt, alle regulär gelisteten Produkte)
   Quelle 2: /collections/<handle>/products.json für Zusatz-Collections – dort liegen Produkte, die in Shopify
             vor Suchmaschinen verborgen sind und deshalb in "all" fehlen (z. B. Totwinkelassistent, Keyless Entry).
   Preisregel: "e" (Preis inkl. Einbau) nur bei Tag "preis-inkl-einbau" – nie aus dem Titel abgeleitet. */
(function () {
  'use strict';
  if (window.LuxData) return;

  var CACHE_KEY = 'luxFinderData:v3';
  var CACHE_TTL = 30 * 60 * 1000;
  var pending = null;

  function readCache() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (parsed && Date.now() - parsed.time < CACHE_TTL) return parsed.products;
    } catch (e) {}
    return null;
  }

  function writeCache(products) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), products: products })); } catch (e) {}
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (text) { return JSON.parse(text); });
  }

  function formatPrice(value) {
    var n = Number(value);
    if (isNaN(n)) return '';
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function fromAjaxProduct(p) {
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/);
    var prices = (p.variants || []).map(function (v) { return Number(v.price); }).filter(function (n) { return !isNaN(n); });
    var min = prices.length ? Math.min.apply(null, prices) : null;
    var img = p.images && p.images.length ? p.images[0].src : null;
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=480';
    return {
      t: p.title,
      u: '/products/' + p.handle,
      i: img,
      p: min === null ? '' : formatPrice(min),
      f: (prices.length > 1 && Math.max.apply(null, prices) !== min) || tags.indexOf('mws-price-from') !== -1,
      e: tags.indexOf('preis-inkl-einbau') !== -1
    };
  }

  function loadEndpoint(endpoint) {
    var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
    return getJSON(endpoint + sep + 'page=1').then(function (first) {
      var pages = Math.min(first.pages || 1, 6);
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(getJSON(endpoint + sep + 'page=' + p));
      return Promise.all(rest).then(function (others) {
        var list = first.products.slice();
        others.forEach(function (o) { list = list.concat(o.products || []); });
        return list;
      });
    });
  }

  function loadExtra(handles) {
    return Promise.all(handles.map(function (h) {
      return getJSON('/collections/' + encodeURIComponent(h) + '/products.json?limit=250')
        .then(function (json) {
          return (json.products || [])
            .filter(function (p) { return p.product_type !== 'mws_apo_generated'; })
            .map(fromAjaxProduct);
        })
        .catch(function () { return []; });
    })).then(function (lists) { return [].concat.apply([], lists); });
  }

  window.LuxData = {
    load: function (endpoint, extraHandles) {
      var cached = readCache();
      if (cached) return Promise.resolve(cached);
      if (pending) return pending;
      var extra = (extraHandles || []).filter(Boolean);
      pending = Promise.all([loadEndpoint(endpoint), loadExtra(extra)]).then(function (res) {
        var seen = {};
        var products = res[0].concat(res[1]).filter(function (p) {
          if (!p || !p.u || seen[p.u]) return false;
          seen[p.u] = true;
          return true;
        });
        writeCache(products);
        pending = null;
        return products;
      }, function (err) {
        pending = null;
        throw err;
      });
      return pending;
    }
  };
})();
